export const setViewportHeight = () => {
  document.documentElement.style.setProperty(
    '--dvh',
    window.innerHeight * 0.01 + 'px'
  )
}

export const viewportAdjust = () => {
  const viewport = document.querySelector('meta[name="viewport"]')
  function switchViewport() {
    const value =
      window.outerWidth > 375
        ? 'width=device-width,initial-scale=1'
        : 'width=375'
    if (viewport.getAttribute('content') !== value) {
      viewport.setAttribute('content', value)
    }
  }
  addEventListener('resize', switchViewport, false)
  switchViewport()
}

export function throttle(fn, wait) {
  var time = Date.now()
  return function() {
    if (time + wait - Date.now() < 0) {
      fn()
      time = Date.now()
    }
  }
}

export function debounce(fn, interval) {
  console.log('deb')
  let timer
  return function() {
    clearTimeout(timer)
    timer = setTimeout(function() {
      fn()
    }, interval)
  }
}
